import { useEffect, useState } from "react";
import auditModuleService from "src/services/auditModuleService";
import { SourceColumn } from "../shared/types";

// ----------------------------  useSourceColumns  ----------------------------
// The sample columns a field can show, loaded once from the backend.

export interface SourceColumnsState {
  columns: SourceColumn[];
  loading: boolean;
  error: boolean;
}

export function useSourceColumns(): SourceColumnsState {
  const [state, setState] = useState<SourceColumnsState>({
    columns: [],
    loading: true,
    error: false,
  });
  useEffect(() => {
    let live = true;
    auditModuleService
      .getSourceColumns()
      .then((columns) => live && setState({ columns, loading: false, error: false }))
      .catch(() => live && setState({ columns: [], loading: false, error: true }));
    return () => {
      live = false;
    };
  }, []);
  return state;
}
